import {endpoints} from '@kapitalist/contract/endpoints'
import type {
  TPathPiecesOf,
  TRequestOf,
  TResponseOf,
} from '@kapitalist/contract/endpoints/types'
import type {TFormError} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import GetWaitingRoomData from '~/api/endpoints/game/PreGame/GetWaitingRoomData'

const endpoint = endpoints.pregame.startGame

export type TStartGameResponse = TResponseOf<typeof endpoint>
type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>

/**
 * Start a game lobby from the waiting room, once all players have joined.
 */
export default class StartGame extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: Params,
    pathPieces: PathPieces
  ): TFormError | null {
    if (pathPieces.gameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return this.defaultMockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TStartGameResponse {
    GetWaitingRoomData.resetMockPlayerCount()
    return {}
  }

  protected transformResponse(r: TStartGameResponse) {
    return r
  }
}
